import Navbar from "./components/Navbar/Navbar";
import Hero from "./components/Hero/Hero";
import Trusted from "./components/Trusted/Trusted";
import About from "./components/About/About";
import Services from "./components/Services/Services";
import WhyChoose from "./components/WhyChoose/WhyChoose";
import Technology from "./components/Technology/Technology";
import CTA from "./components/CTA/CTA";
import Portfolio from "./components/Portfolio/Portfolio";
import Team from "./components/Team/Team";
import Testimonials from "./components/Testimonials/Testimonials";
import Counter from "./components/Counter/Counter";
import Products from "./components/Products/Products";
import Process from "./components/Process/Process";
import CSC from "./components/CSC/CSC";
import FAQ from "./components/FAQ/FAQ";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";

function App() {
    if (window.location.pathname === "/csc") {
    return <CSC />;
  }
  return (
    <>
      <Navbar />
      <Hero />
      <Trusted />
      <About />
      <Services />
      <Products />
      <WhyChoose />
      <Process />
<Technology />
<CTA />
<Portfolio />
<Team />
<Testimonials />
<Counter />
<FAQ />
<Contact />
<Footer />

    </>
  );
}

export default App;